<div class="connectionstatus">
    <div class="title">{{title}}</div>
    <div class="chart"> 
      <svg viewBox="0 0 40 40" class="donut">
        <circle v-for="val in state.Data" class="donut-segment" :stroke=val.color :stroke-dasharray=val.dasharray cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="2" stroke-dashoffset="25"></circle>
      </svg>
      <div class="total_Ratio">{{state.total_ratio}}%</div>
      <div class="total_text">{{total_text}}</div>
    </div>
    <table ref="root">
      <thead>
          <tr>
              <th>{{table_title_name}}</th>
              <th
              @mouseover="hoverEffect($event,t('__d7d_n17r.__amount') ,1)"
              @mouseleave="hoverEffect($event,'' , 0)" >
                <span class="normalTd textLimit">{{t('__d7d_n17r.__amount')}}</span>
                <div class="textLimitHoverBlock" v-if=" state.hoverRow == 1 "
                :class="{'opacity': state.hoverRow == 1, 'rightPosition': state.hoverRow == 1 }">{{state.mouseOver}}</div>
              </th>
              <th              @mouseover="hoverEffect($event,t('__d7d_n17r.__ratio') ,2)"
              @mouseleave="hoverEffect($event,'' , 0)" >
                <span class="normalTd textLimit">{{t('__d7d_n17r.__ratio')}}</span>
                <div class="textLimitHoverBlock" v-if=" state.hoverRow == 2 "
                :class="{'opacity': state.hoverRow == 2, 'rightPosition': state.hoverRow == 2 }">{{state.mouseOver}}</div>
              </th>
          </tr>
      </thead>
      <div class="spacer"></div>
      <tbody>
          <tr v-for="val in state._data"><td><div class="color" :style="{background:val.color}"></div>{{val.name}}</td><td>{{val.amount}}</td><td>{{val.ratio}}%</td></tr>
      </tbody>
  </table>
  
</div>